/* Lazy video: nothing downloads until the player is near the viewport; then autoplay muted (per data-ga-autoplay), pause when scrolled away. */
(function () {
  "use strict";
  var desktop = window.matchMedia("(min-width: 990px)").matches;
  function arm(v) {
    if (v.dataset.gaArmed) return; v.dataset.gaArmed = "1";
    var host = v.closest("[data-ga-lazy]"); var mode = (host && host.dataset.gaLazy) || "all";
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          if (v.preload === "none") v.preload = "metadata";
          if (mode === "all" || (mode === "desktop" && desktop)) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (!v.paused && !v.controls) { v.pause(); }
        else if (!v.paused && (mode === "all" || (mode === "desktop" && desktop))) { v.pause(); }
      });
    }, { rootMargin: "200px 0px" });
    io.observe(v);
  }
  function init() { document.querySelectorAll("[data-ga-lazy] video").forEach(arm); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", init);
})();
